import {Component, OnDestroy, OnInit} from '@angular/core';
import {AsideService} from '../../aside/aside.service';
import {UserStateService} from '../../user/user.state.service';
import {User} from '../../user/user';
import {Subscription} from 'rxjs';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {UploadStateService} from '../../upload/upload-state.service';
import {UserService} from '../../user/user.service';
import {NavStatusService} from '../../nav-status.service';
import {NavigationPoint} from '../../navigation-point';
import {MatDialog} from '@angular/material/dialog';
import {EditProfileComponent} from '../../edit-profile/edit-profile.component';
import {SnackBarService} from '../../common/snack-bar-service';
import {LanguageChooserComponent} from "../language-chooser/language-chooser.component";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'app-user-bar',
  imports: [
    MatIcon,
    MatButton,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    MatIconButton,
    TranslatePipe,
    LanguageChooserComponent,
    MatTooltip
  ],
  templateUrl: './user-bar.component.html',
  styleUrl: './user-bar.component.scss'
})
export class UserBarComponent implements OnInit, OnDestroy{
  user: User  | undefined | null;
  userSubscription: Subscription | undefined;

  constructor(private asideService: AsideService,
              private userStateService: UserStateService,
              private userService: UserService,
              private translate: TranslateService,
              private router: Router,
              private  uploadStateService: UploadStateService,
              private navStateService: NavStatusService,
              private dialog: MatDialog,
              private snackService: SnackBarService) {
  }
  ngOnInit() {
    this.userSubscription = this.userStateService.user$.subscribe( user => {
        this.user = user;
    })
  }
  login() {
    this.navStateService.setActiveNavPoint(NavigationPoint.login);
    this.router.navigate(['login']);
  }
  loadLanguage(lang: string) {
    this.translate.get(lang);
    this.translate.use(lang);
    this.translate.defaultLang = lang;
    // console.log('currentlang', this.translate.currentLang)
  }
  openUpload() {
    this.uploadStateService.mode = 'new';
  }
  logout() {
    //this.router.navigate(['login']);
    if (this.user && !this.user.originalUser) {
      this.userService.logout().subscribe(
          res => {
            this.navStateService.setActiveNavPoint(NavigationPoint.login);
            this.router.navigate(['login']).then();
          }
      );
    } else {
      if (this.user && this.user.originalUser && this.user.originalUser.username) {
        this.userService.switchUserBackPost().subscribe(res => {
          if (res && res.ok) {
            this.userService.getLoggedInUser().subscribe(user => {
              this.userStateService.user = user
              this.router.navigate(['user-admin']).then();
            })
          }
        })
      }
    }

  }
  mangeUsers() {
    this.router.navigate(['user-admin']).then();
  }
  editUser() {
    const ref = this.dialog.open(EditProfileComponent, {
      width: '600px',
      data: this.user,
      autoFocus: false
    });
    ref.afterClosed().subscribe(result => {
      if (result) {
        this.userService.updateUser(result).subscribe(res => {
             // console.log('updated user', res);
              this.userStateService.user = res;
              this.snackService.showMessage({
                success: true,
                message: 'update.user.success',})
            }, error => {
              console.log(error);
              this.showError();
            }
        )
      }
    })
  }
  showError(): void {
    this.snackService.showMessage({
      success: false,
      message: 'update.user.error'
    })
  }
  showAside() {
    this.asideService.setShowAside(true);
  }
  ngOnDestroy() {
    this.userSubscription?.unsubscribe();
  }

}
